
<template>
	<page>
		<module>
			<view-list
				ref="view"
				work-type="14"
				selector
			>
				<template #search>
					<m-search ref="search">
						<m-search-item label="背贴码">
							<m-code-batch-input name="produce_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="IMEI">
							<m-code-batch-input name="imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="产品信息">
							<c-input name="product_name" placeholder="产品名称"></c-input>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #product_info="{data}">
					<m-product-info :name="data.product_name || '-'" :level="data.level_type" :code="data.produce_code" :imei="data.imei"></m-product-info>
				</template>

				<template #max_sale_price="{data}">
					<span style="color: #e53e3e;">{{formatPrice(data.max_sale_price)}}</span>
				</template>

				<template #confirm_sale_price="{data}">
					{{formatPrice(data.confirm_sale_price)}}
				</template>

				<template #expect_settle_price="{data}">
					{{formatPrice(data.expect_settle_price)}}
				</template>

				<template #confirm_channel_id="{data}">
					{{data.confirm_channel_name || '-'}}
				</template>

				<template #produce_code="{data}">
					{{data.produce_code}} <c-link color="gray" @click="$copy(data.produce_code)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #imei="{data}">
					{{data.imei}} <c-link v-if="data.imei" color="gray" @click="$copy(data.imei)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #handle_state="{data}">
					<c-state async dict="OVERSOLD_HANDLE_STATE" :value="data.handle_state"></c-state>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="120"
					button-limit="6"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_oversold_order_query')" icon="tf-detail" @click="viewDetail(data)">查看详情</c-table-button>
						<c-table-button v-if="auth('b_oversold_order_confirm_handle') && data.handle_state == 1" icon="tf-edit" @click="handleOversold(data)">处理</c-table-button>
						<c-table-button v-if="auth('b_oversold_order_operate_log')" icon="tf-detail" @click="loadWorkLogDetail()">操作记录</c-table-button>
					</template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
	export default {
		methods: {
			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********查看详情（只读）**********/
			viewDetail(data) {
				this.globalDialog('oversoldDetail', {
					data: {
						oversoldId: data.id
					}
				}, () => {
					this.$refs.view.update();
				});
			},

			/*********处理超卖（可选保留订单）**********/
			handleOversold(data) {
				this.globalDialog('oversoldDetail', {
					props: {
						handleable: true
					},
					data: {
						oversoldId: data.id
					}
				}, () => {
					this.$refs.view.update();
				});
			},

			/*********加载系统业务日志列表**********/
			loadWorkLogDetail() {
				this.globalDialog('workLogDetail', {
					props: {
						workType: 14
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-product-info {
		line-height: 24px;
		font-size: 13px;
		color: #333;

		.m-product-info-name {
			display: flex;
			align-items: center;
			gap: 4px;
		}
	}
</style>
